module.exports = __webpack_public_path__ + "static/media/pattern-6.ff61e316.png";